// extracted by mini-css-extract-plugin
export var bubble = "_t-0";
export var container = "_t-f";
export var contrastBorder = "_t-g";
export var greyOut = "_t-2";
export var initialsColor0 = "_t-3";
export var initialsColor1 = "_t-4";
export var initialsColor10 = "_t-d";
export var initialsColor11 = "_t-e";
export var initialsColor2 = "_t-5";
export var initialsColor3 = "_t-6";
export var initialsColor4 = "_t-7";
export var initialsColor5 = "_t-8";
export var initialsColor6 = "_t-9";
export var initialsColor7 = "_t-a";
export var initialsColor8 = "_t-b";
export var initialsColor9 = "_t-c";
export var initialsWrapper = "_t-1";
export var large = "_t-l";
export var medium = "_t-k";
export var mediumSmall = "_t-j";
export var mediumSmallMedium = "_t-o";
export var micro = "_t-h";
export var small = "_t-i";
export var tiny = "_t-n";
export var xTiny = "_t-m";